
/*
    Requests for values which are used multiple times within the app,
    especially as part of filter values
    - locations
    - routes
    - lanes
    - runs
    - starters
*/

import axios from "axios";
import BaseValues from "./BaseValues";

// locations
export const getLocations = () => {

    const data = BaseValues.createFormData({});

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getLocations`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

// routes
export const getRoutes = (location) => {
    console.log("get routes location", location)

    const data = BaseValues.createFormData({locationid: location});

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getRoutes`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config)
    .then(res => {
        console.log("ROUTES RETURNS DATA?", res);
        return res;
    })
    .catch(BaseValues.handleError);
}

// lanes
export const getLanes = (params) => {
    // location, routes, runs
    console.log("get Lanes params", params);
    const data = BaseValues.createFormData(params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getPlatformList`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

// run
export const getRuns = (params) => {
    console.log("get Runs params", params);
    const data = BaseValues.createFormData(params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getRuns`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

// starter
export const getStarters = (location) => {
    console.log("get starters params", location);
    const data = BaseValues.createFormData({location});

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getStarters`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
export const getVehicleIDs = (params) => {
    console.log("getVehicleIDs PARAMETERS", params);

    // location, route, runId
    const data = BaseValues.createFormData(params);

    const url = `${BaseValues.BaseURL}/api/BUSConsole/getVehicleIDs`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}
